<template>
<div id="page-top" class="member-page-body">
        <!-- Navigation-->
        <nav class="navbar navbar-expand-lg bg-secondary text-uppercase fixed-top" id="mainNav">
            <div class="container">
                <img class="navbar-brand" href="#page-top" src="../assets/philcare-logo.png"/>
                    <i class="fas fa-bars"></i>
            </div>
        </nav>
        <section class="page-section portfolio member-page-section" id="portfolio">
            <div class="container">

              <!--<div v-if="step === 'A'">
                  A
                </div>
                <div v-else-if="step === 'B'">
                   B
                </div>
                <div v-else-if="step === 'C'">
                  C
                </div>
                <div v-else>
                  Not A/B/C
                </div>-->
                <div class="row align-items-start">
                    <div class="col loa-steps steps-active">
                      1
                    </div>
                    <div class="col loa-steps">
                      2
                    </div>
                    <div class="col loa-steps">
                      3
                    </div>
                    
                <div class="row justify-content-center loa-form">
                    <form class="form-inline" @submit.prevent="handleSearch" >
                    <div class="login-form">
                        <p class="h4">WHO IS YOUR DOCTOR?</p>
                        <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">Last Name*</label>
                            <div class="col-sm-10">
                              <input v-model="LastName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search">
                            </div>
                       </div>
                       <div class="mb-3 row">
                            <label for="exampleFormControlTextarea1" class="col-sm-2 col-form-label">First Name*</label>
                            <div class="col-sm-10">
                              <input v-model="FirstName" class="form-control" id="exampleFormControlTextarea1" type="search" aria-label="Search">
                            </div>
                            <div>
                        <b-button v-b-modal.modal-scrollable type="submit" class="search-btn">Search</b-button>

                        <b-modal id="modal-scrollable" scrollable title="List of Doctors:">
                            <p class="my-4" v-for="item in Doctors" :key="item.DoctorCode" >
                            {{item.DoctorName}}<br>
                            {{item.Specialization}}<br>
                            {{item.TelNo}}
                            </p>
                        </b-modal>
                        </div>
                       </div>
                    </div>
                       <div class="col-md-12 member-custom-btn">
                  <a style="float:left" type="button" class="btn btn-primary btn-lg"><router-link to="/member-page">CANCEL</router-link></a>
                  <a type="button" class="btn btn-primary btn-lg"><router-link to="/loa-consultation">PREVIOUS</router-link></a>
                  <button class="btn btn-primary btn-lg"><router-link to="/loa-page-3">NEXT</router-link></button>
            </div>
                    </form>
                </div>  
                </div>       
        </div>
                                
        </section>
</div>
</template>


<script>
import axios from 'axios';
export default {
  name: 'DoctorName',
  data() {
    return {
      certNo: '',
      TokenID: '',
      LastName: '',
      FirstName: '',
      Doctors: [],
      step:"B"


    }
  },
  methods: {
    async handleSearch() {
      this.TokenID = localStorage.getItem('TokenID')
        const response = await axios.post('/api/?action=member-doctor-name', {
           FirstName: this.FirstName,
           TokenID: this.TokenID,
           LastName: this.LastName
        }, 
        );

        console.log(response);
        this.Doctors=response.data

        
        
    }
    
  }
  }



</script>


<!-- Add "scoped" attribute to limit CSS to this component only -->
